export default "/images/volume-1.svg?868e1073a6e6fe40af426dcd39a0268c";